import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postREJwtLogin = (data) => api.create(url.POST_LOGIN, data);

export const getSignIn = (data) => api.create(url.POST_LOGIN, data);

// CRM
// get Users
export const getUsers = () => api.get(url.GET_USERS);
export const getUsersActivity = () => api.get(url.GET_USERS_ACTIVITY);

// add User
export const addNewUser = (contact) => api.create(url.ADD_NEW_USER, contact);

// update User
export const updateUser = (contact) =>
  api.put(url.UPDATE_USER + "/" + contact._id, contact);

// delete User
export const deleteUser = (contact) =>
  api.delete(url.DELETE_USER + "/" + contact);

// Campaign
// get Campaigns
export const getCampaigns = () => api.get(url.GET_CAMPAIGNS);

export const getCampaignsSpecial = (campaign) =>
  api.get(url.GET_CAMPAIGNS_SPECIAL + "?toirog=" + campaign.toirog);

// add Campaign
export const addNewCampaign = (campaign) =>
  api.create(url.ADD_NEW_CAMPAIGN, campaign);

// update Campaign
export const updateCampaign = (campaign) =>
  api.put(url.UPDATE_CAMPAIGN + "/" + campaign._id, campaign);

// delete Campaign
export const deleteCampaign = (campaign) =>
  api.delete(url.DELETE_CAMPAIGN + "/" + campaign);

// Posts
// get Posts
export const getAllPosts = (post) => {
  let urlString =
    url.GET_ALL_POSTS +
    "?type=all" +
    "&taskId=" +
    post.taskId +
    "&total=" +
    post.isTotal +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

const buildUrlWithParams = (baseUrl, params) => {
  const query = Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => {
      if (Array.isArray(v)) {
        return v
          .map((val) => `${encodeURIComponent(k)}=${encodeURIComponent(val)}`)
          .join("&");
      }
      return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
    })
    .join("&");
  return baseUrl + (query ? "?" + query : "");
};

export const getFBPosts = (post) => {
  let urlString =
    url.GET_FB_POSTS +
    "?type=fb" +
    "&taskId=" +
    post.taskId +
    "&total=" +
    post.isTotal +
    "&page=" +
    post.page +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    // If attitude is an array, join by comma, otherwise just add it
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

export const getTWPosts = (post) => {
  let urlString =
    url.GET_TW_POSTS +
    "?type=tw" +
    "&taskId=" +
    post.taskId +
    "&total=" +
    post.isTotal +
    "&page=" +
    post.page +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    // If attitude is an array, join by comma, otherwise just add it
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

export const getNWPosts = (post) => {
  let urlString =
    url.GET_NW_POSTS +
    "?type=nw" +
    "&taskId=" +
    post.taskId +
    "&total=" +
    post.isTotal +
    "&page=" +
    post.page +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    // If attitude is an array, join by comma, otherwise just add it
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

export const getIGPosts = (post) => {
  let urlString =
    url.GET_IG_POSTS +
    "?type=ig" +
    "&taskId=" +
    post.taskId +
    "&total=" +
    post.isTotal +
    "&page=" +
    post.page +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    // If attitude is an array, join by comma, otherwise just add it
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

// export const getFBPosts = (post) => {
//   const params = {
//     type: "fb",
//     taskId: post.taskId,
//     total: "no",
//     page: post.page,
//     text: post.text,
//     startDate: post.startDate,
//     endDate: post.endDate,
//     attitude: post.attitude, // can be string or array
//   };
//   const urlWithParams = buildUrlWithParams(url.GET_FB_POSTS, params);
//   return api.get(urlWithParams);
// };

export const getRPTPosts = (post) => {
  const params = {
    taskId: post.taskId,
    startDate: post.startDate,
    endDate: post.endDate,
    attitude: post.attitude,
  };
  const urlWithParams = buildUrlWithParams(url.GET_RPT_POSTS, params);
  return api.get(urlWithParams);
};

// export const getTWPosts = (post) => {
//   const params = {
//     type: "tw",
//     taskId: post.taskId,
//     total: "no",
//     page: post.page,
//     text: post.text,
//     startDate: post.startDate,
//     endDate: post.endDate,
//     attitude: post.attitude,
//   };
//   const urlWithParams = buildUrlWithParams(url.GET_TW_POSTS, params);
//   return api.get(urlWithParams);
// };

// export const getNWPosts = (post) => {
//   const params = {
//     type: "nw",
//     taskId: post.taskId,
//     total: "no",
//     page: post.page,
//     text: post.text,
//     startDate: post.startDate,
//     endDate: post.endDate,
//     attitude: post.attitude,
//   };
//   const urlWithParams = buildUrlWithParams(url.GET_NW_POSTS, params);
//   return api.get(urlWithParams);
// };

// export const getIGPosts = (post) => {
//   const params = {
//     type: "ig",
//     taskId: post.taskId,
//     total: "no",
//     page: post.page,
//     text: post.text,
//     startDate: post.startDate,
//     endDate: post.endDate,
//     attitude: post.attitude,
//   };
//   const urlWithParams = buildUrlWithParams(url.GET_IG_POSTS, params);
//   return api.get(urlWithParams);
// };

export const getTop10Posts = (post) => {
  let urlStr = url.GET_TOP10_POSTS + "?taskId=" + post.taskId;
  urlStr += "&text=" + post.text;
  if (post.source) urlStr += "&source=" + post.source;
  urlStr += "&startDate=" + post.startDate;
  urlStr += "&endDate=" + post.endDate;
  if (post.limit) urlStr += "&limit=" + post.limit;
  if (post.page) urlStr += "&page=" + post.page;
  return api.get(urlStr);
};

export const getTheLatestPosts = (post) => {
  let urlStr = url.GET_THELATEST_POSTS + "?taskId=" + post.taskId;
  urlStr += "&text=" + post.text;
  if (post.source) urlStr += "&source=" + post.source;
  urlStr += "&startDate=" + post.startDate;
  urlStr += "&endDate=" + post.endDate;
  if (post.limit) urlStr += "&limit=" + post.limit;
  if (post.page) urlStr += "&page=" + post.page;
  return api.get(urlStr);
};

export const getStatsPosts = (post) => {
  const params = new URLSearchParams({ taskId: post.taskId, source: post.source });
  if (post.startDate && post.endDate) {
    params.set("startDate", post.startDate);
    params.set("endDate", post.endDate);
  } else {
    params.set("dateRange", post.dateRange);
  }
  return api.get(`${url.GET_STATS_POSTS}?${params.toString()}`);
};

export const getTotalStatsPosts = (post) => {
  const params = new URLSearchParams({ taskId: post.taskId });
  if (post.source) params.set("source", post.source);
  if (post.startDate && post.endDate) {
    params.set("startDate", post.startDate);
    params.set("endDate", post.endDate);
  } else {
    params.set("dateRange", post.dateRange);
  }
  return api.get(`${url.GET_TOTALSTATS_POSTS}?${params.toString()}`);
};

export const getRPTStatsPosts = (post) =>
  api.get(
    url.GET_RPTSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=" +
      post.source +
      "&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getRPTStatsFBPosts = (post) =>
  api.get(
    url.GET_RPTSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=facebook&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getRPTStatsTWPosts = (post) =>
  api.get(
    url.GET_RPTSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=twitter&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getRPTStatsNWPosts = (post) =>
  api.get(
    url.GET_RPTSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=news&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getRPTStatsIGPosts = (post) =>
  api.get(
    url.GET_RPTSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=instagram&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getRPTTotalStatsPosts = (post) =>
  api.get(
    url.GET_RPTTOTALSTATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=" +
      post.source +
      "&startDate=" +
      post.startDate +
      "&endDate=" +
      post.endDate
  );

export const getTotalStatsQueryPosts = (post) => {
  let urlString =
    url.GET_TOTALSTATS_QUERY_POSTS +
    "?taskId=" +
    post.taskId +
    "&source=" +
    post.source +
    "&text=" +
    encodeURIComponent(post.text || "") +
    "&startDate=" +
    post.startDate +
    "&endDate=" +
    post.endDate;

  if (post.attitude) {
    // If attitude is an array, join by comma, otherwise just add it
    const attitudeParam = Array.isArray(post.attitude)
      ? post.attitude.join(",")
      : post.attitude;

    urlString += "&attitude=" + encodeURIComponent(attitudeParam);
  }

  return api.get(urlString);
};

export const getTotalLikesCounts = (post) => {
  const params = new URLSearchParams({ taskId: post.taskId });
  if (post.startDate && post.endDate) {
    params.set("startDate", post.startDate);
    params.set("endDate", post.endDate);
  } else {
    params.set("dateRange", post.dateRange);
  }
  return api.get(`${url.GET_TOTAL_LIKES_COUNTS}?${params.toString()}`);
};

export const getTopSourceVolume = (post) => {
  const params = new URLSearchParams({ taskId: post.taskId });
  if (post.startDate && post.endDate) {
    params.set("startDate", post.startDate);
    params.set("endDate", post.endDate);
  } else {
    params.set("dateRange", post.dateRange);
  }
  return api.get(`${url.GET_TOP_SOURCE_VOLUME}?${params.toString()}`);
};

export const getStatsFBPosts = (post) =>
  api.get(
    url.GET_STATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=facebook&dateRange=" +
      post.dateRange
  );

export const getStatsTWPosts = (post) =>
  api.get(
    url.GET_STATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=twitter&dateRange=" +
      post.dateRange
  );

export const getStatsNWPosts = (post) =>
  api.get(
    url.GET_STATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=news&dateRange=" +
      post.dateRange
  );

export const getStatsIGPosts = (post) =>
  api.get(
    url.GET_STATS_POSTS +
      "?taskId=" +
      post.taskId +
      "&source=instagram&dateRange=" +
      post.dateRange
  );

// add Post
export const addNewPost = (post) => api.create(url.ADD_NEW_POST, post);

// update Post
export const updatePost = (post) =>
  api.put(url.UPDATE_POST + "/" + post._id, post);

// delete Post
export const deletePost = (post) => api.delete(url.DELETE_POST + "/" + post);

export const markPostAsRead = (data) => api.create(url.MARK_POST_AS_READ, data);
export const getUserReadPosts = (post) => api.get(url.GET_USER_READ_POSTS + (post.taskId ? "?taskId=" + post.taskId : ""));
export const getTasksWithCounts = () => api.get(url.GET_TASKS_WITH_COUNTS);
export const updateAnalyzeHistory = ({ id, period, data }) =>
  api.put(`${url.UPDATE_ANALYZE_HISTORY}/${id}/analyze-history`, { period, data });
export const getMonthlyTrend = (params) => api.get(url.GET_MONTHLY_TREND, { params });
export const toggleFavoritePost = (data) => api.create(url.TOGGLE_FAVORITE_POST, data);
export const getUserFavorites = (post) => api.get(url.GET_USER_FAVORITES + (post.taskId ? "?taskId=" + post.taskId : ""));
export const toggleSavedPost = (data) => api.create(url.TOGGLE_SAVED_POST, data);
export const getUserSaved = (userId) => api.get(url.GET_USER_SAVED, { params: { userId } });

export const getWordCloud = (params) => {
  let urlStr = url.GET_WORD_CLOUD + "?taskId=" + params.taskId;
  if (params.startDate) urlStr += "&startDate=" + params.startDate;
  if (params.endDate) urlStr += "&endDate=" + params.endDate;
  if (params.dateRange) urlStr += "&dateRange=" + params.dateRange;
  return api.get(urlStr);
};

export const getTopUsers = (params) => {
  const p = new URLSearchParams({ taskId: params.taskId });
  if (params.startDate && params.endDate) {
    p.set("startDate", params.startDate);
    p.set("endDate", params.endDate);
  } else if (params.dateRange) {
    p.set("dateRange", params.dateRange);
  }
  return api.get(`${url.GET_TOP_USERS}?${p.toString()}`);
};

// News
// get News
export const getNews = () => api.get(url.GET_NEWS);

// add News
export const addNewNews = (news) => api.create(url.ADD_NEW_NEWS, news);

// update News
export const updateNews = (news) =>
  api.put(url.UPDATE_NEWS + "/" + news._id, news);

// delete News
export const deleteNews = (news) => api.delete(url.DELETE_NEWS + "/" + news);

// NewsPosts
// get News
export const getNewsPosts = (newsposts) => {
  let urlStr = url.GET_NEWS_POSTS + "?page=" + (newsposts.page || 1) + "&limit=" + (newsposts.limit || 50);
  if (newsposts.text) urlStr += "&text=" + encodeURIComponent(newsposts.text);
  if (newsposts.source && newsposts.source !== "Бүгд") urlStr += "&source_sub=" + encodeURIComponent(newsposts.source);
  return api.get(urlStr);
};

// add News
export const addNewNewsPost = (newsposts) =>
  api.create(url.ADD_NEW_NEWS_POSTS, newsposts);

// update News
export const updateNewsPost = (newsposts) =>
  api.put(url.UPDATE_NEWS_POSTS + "/" + newsposts._id, newsposts);

// delete News
export const deleteNewsPost = (newsposts) =>
  api.delete(url.DELETE_NEWS_POSTS + "/" + newsposts);
// Inquiries
export const getQuotes = () => api.get(url.GET_QUOTES);
export const deleteQuote = (id) => api.delete(url.GET_QUOTES + "/" + id);
export const updateQuoteStatus = (id, status) => api.patch(url.GET_QUOTES + "/" + id, { status });

export const getSubscribers = () => api.get(url.GET_SUBSCRIBERS);
export const deleteSubscriber = (id) => api.delete(url.GET_SUBSCRIBERS + "/" + id);
